import { useState, useEffect, useRef, useMemo } from 'react';
import { Button, Menu, message, Modal, Spin } from 'antd';
import styles from './index.module.less';
import PageWrapper from '@/components/page-wrapper';
import { SearchFilter, SearchInput, useSearchFiler, SearchSite } from '@/components/ptx-search';
import AddComBtn from './components/addBtn';
import Transfer from './components/transfer';
import FileType from './components/fileType';
import AppType from './components/appType';
import VersionModel from './components/version';
import PtxTable from '@/components/ptx-table';
import UpdateElement from './components/updateElement';
import ComponentAdd from './components/add';
import SearchTag from './components/searchTag';
import classNames from 'classnames';
import ModalLabel from '../label/index2';
import { Edit, EmptyMemberColor, AlertFilled } from 'patternx-svg';
// import { history } from 'umi';
import { transferStatus as transferStatusEnum } from './enum';
import { Download, HistoricVersion, Delete, Unshelve, Shelve } from 'patternx-svg';
import { cloneDeep, get, intersectionBy } from 'lodash-es';
import searchStore from '../../searchStore';
import {
  getComponents,
  getComponentTags,
  getComponentApps,
  deleteComponent,
  updateComponentLineStatus,
  getComponentDownUrl,
  getComponentBase,
  batchDownloadComponents,
  updateComponentCategory,
  updateComponentApp,
  exportFileApi,
  batchUpdateComponents,
} from '@/services/source';
import { isDownloadable } from '@/services/element';
import { useCallbackFn } from '@/hooks';
import { downLoadFile, downLoadFileByBlob } from '@/utils/utils';
import ViewElement from './components/view';
// import dayjs from 'dayjs';
import ChangeCategoryModal from './components/ChangeCategory';
import ChangeAppModal from './components/ChangeApp';
import { useSetRecoilState } from 'recoil';
import { exportModalVisibleStore } from '@/store';
import { getDirectionTypeDicts } from '@/services/rule';
import BatchEdit from './components/batchEdit';

const initLoadState = {
  isLoading: false,
  isEmpty: false, // 页面没数据
  isNoData: false, // 搜索没数据
  isLoadFail: false,
  total: 0,
  current: 1,
  pageSize: 20,
  list: [] as any[],
  pageCount: 0,
  isFirstLoading: true,
};

interface ElementProps {
  choiceMode?: boolean;
  onChoice?: (info: any) => void;
}

export const useDebouncedEffect = (effect: any, deps: any, delay: any) => {
  useEffect(() => {
    const handler = setTimeout(() => effect(), delay);

    return () => clearTimeout(handler);
  }, [...(deps || []), delay]);
};

const Element = (props: ElementProps) => {
  const { choiceMode = false, onChoice } = props;
  const [data, setData] = useState(initLoadState);
  const [visibleAdd, setVisibleAdd] = useState<boolean>(false);
  const [visibleTag, setVisibleTag] = useState<boolean>(false);
  const [visibleVersion, setVisibleVersion] = useState<boolean>(false);
  const [tagCode, setTagCode] = useState<string>('');
  const [componentName, setComponentName] = useState<string>('');
  const [transferStatus, setTransferStatus] = useState<string>(
    choiceMode ? transferStatusEnum.transfered : '',
  );
  const [fileType, setFileType] = useState<string>('');
  const [appType, setAppType] = useState<string>('');

  const [labels, setLabels] = useState<ELEMENT.ResLabelItem[]>([]);
  const [apps, setApps] = useState<any[]>([]);
  const [state, dispatch] = useSearchFiler();
  const [updateInfo, setUpdateInfo] = useState({
    visible: false,
    activeData: {},
  });
  const [selectedElements, setSelectedElements] = useState<ELEMENT.Component[]>([]);
  const operationItem = useRef<ELEMENT.Component>();
  const tagRef = useRef<any>();
  const tranRef = useRef<any>();
  const fileTypeRef = useRef<any>();
  const appTypeRef = useRef<any>();

  const [showView, setShowView] = useState(false);
  const [viewData, setViewData] = useState<ELEMENT.Component>();

  const [isEditCategoryOpen, setIsEditCategoryOpen] = useState(false);
  const [isEditAppOpen, setIsEditAppOpen] = useState(false);

  const [addType, setAddType] = useState('');
  //导出
  const setExportModalVisble = useSetRecoilState(exportModalVisibleStore);

  //行为规则
  const [adsorptionCategorys, setAdsorptionCategorys] = useState<any[]>([]);
  const [referencePointHorizontals, setReferencePointHorizontals] = useState<any[]>([]);
  const [referencePointVerticals, setReferencePointVerticals] = useState<any[]>([]);
  const [referenceFaceVerticals, setReferenceFaceVerticals] = useState<any[]>([]);
  const [referenceFaceHorizontals, setReferenceFaceHorizontals] = useState<any[]>([]);
  const [targetHosts, setTargetHosts] = useState<any[]>([]);

  //批量编辑
  const [showBatchEdit, setShowBatchEdit] = useState(false);

  const getElementsFirst = async (page: number = 1, pageSize: number = 10) => {
    setData((states) => ({ ...states, isLoading: true }));
    const params = {
      page: page,
      pageSize: pageSize,
      name: componentName,
      // transferStatus: transferStatus === 'transfered/lack' ? 'transfered' : transferStatus,
      suffix: fileType ?? '',
      status: transferStatus || '',
      appList: appType ? [appType] : [],
      // orderBy: 'name',
      tagList: tagCode ? [tagCode] : [],
    };
    const res = await getComponents(params);
    const lists: any[] = res?.data?.details?.list || [];
    const pageInfo = res?.data?.details?.page;
    /// 这种情况发生在删除最后一页全部数据的时候
    if (lists?.length == 0 && pageInfo?.pageNum > pageInfo?.pages && pageInfo?.pages != 0) {
      getElementsFirst(pageInfo?.pages || 1, pageInfo?.pageSize || 10);
      return;
    }

    if (selectedElements.length) {
      setSelectedElements((list) => intersectionBy(lists, list, 'id'));
    }

    lists?.forEach((i: any) => {
      if (
        i?.status === transferStatusEnum.transfering ||
        i?.status === transferStatusEnum.waiting
      ) {
        i.extra = <div className={classNames(styles.cardTag)}>转换中</div>;
      }
      if (i?.status === transferStatusEnum.fail) {
        i.extra = <div className={classNames(styles.cardTag, styles.cardTagDanger)}>转换失败</div>;
      }
      if (i?.status === 'osOnline') {
        i.extra = <div className={classNames(styles.cardTag, styles.cardTagOnLine)}>上架</div>;
      }
      if (i?.status === 'osOffline') {
        i.extra = <div className={classNames(styles.cardTag, styles.cardTagOffLine)}>下架</div>;
      }
      i.isAllowSetting = i.category !== 'gmodeler' ? true : !!i.adsorptionCategory;
    });
    setData((v) => ({
      ...v,
      isLoading: false,
      isEmpty: res?.success
        ? state.count == 0 && !componentName && page == 1 && lists?.length == 0
        : true,
      total: pageInfo?.total || 0,
      list: lists,
      current: pageInfo?.pageNum || 1,
      pageSize: pageInfo?.pageSize || 10,
      pageCount: pageInfo?.pages || 0,
      isNoData: lists.length == 0,
      isFirstLoading: false,
    }));
  };

  const getLabels = async () => {
    const res = await getComponentTags();
    if (res?.success) {
      setLabels(res?.data?.details || []);
      if (Object.keys(searchStore.getElement()).length > 0) {
        const tmp = searchStore.getElement();
        setTagCode(tmp.tag || '');
        setTransferStatus(tmp.transfer || '');
        setFileType(tmp.fileType || '');
        setAppType(tmp.appType || '');
        tagRef.current._setSelectValue(tmp.tagIds || []);
        tranRef.current._setSelectValue(tmp.transferId || []);
        fileTypeRef.current._setSelectValue(tmp.fileType || '');
        appTypeRef.current._setSelectValue(tmp.appType || '');
        dispatch({ type: 'focus', payload: true });
        dispatch({ type: 'count', payload: tmp.count });
      }
    }
  };

  const getApps = async () => {
    const res = await getComponentApps('app', false);
    if (res?.success) {
      setApps(res?.data?.details || []);
      if (Object.keys(searchStore.getElement()).length > 0) {
        const tmp = searchStore.getElement();
        setTagCode(tmp.tag || '');
        setTransferStatus(tmp.transfer || '');
        setFileType(tmp.fileType || '');
        setAppType(tmp.appType || '');
        tagRef.current._setSelectValue(tmp.tagIds || []);
        tranRef.current._setSelectValue(tmp.transferId || []);
        fileTypeRef.current._setSelectValue(tmp.fileType || '');
        appTypeRef.current._setSelectValue(tmp.appType || '');
        dispatch({ type: 'focus', payload: true });
        dispatch({ type: 'count', payload: tmp.count });
      }
    }
  };

  const onRefreshData = useCallbackFn((isRequestPrev?: boolean) => {
    let currentPage = data.current;
    if (isRequestPrev) {
      currentPage = currentPage - 1 < 1 ? 1 : currentPage - 1;
    }
    getElementsFirst(currentPage, data.pageSize);
  });

  useDebouncedEffect(
    getElementsFirst,
    [tagCode, componentName, transferStatus, fileType, appType],
    300,
  );

  const customOptionLabel = (item: any) => (
    <div className={`${styles.customOption} customOption`}>{item.name}</div>
  );

  const getDicts = async (code: string, callback: Function, valueType: string) => {
    const res = await getDirectionTypeDicts(code);
    const dicts =
      res?.data?.dicts?.map((r: any) => {
        const isCustom =
          code === 'gmodeler_component_adsorption_category' && r[valueType] === 'custom';
        return {
          value: r[valueType],
          label: isCustom ? customOptionLabel(r) : r.name,
          extend: r.extend,
        };
      }) || [];
    callback(dicts);
  };

  const getSelectOptions = () => {
    getDicts('gmodeler_component_adsorption_category', setAdsorptionCategorys, 'code');
    getDicts('referencePointHorizontal', setReferencePointHorizontals, 'value');
    getDicts('referencePointVertical', setReferencePointVerticals, 'value');
    getDicts('referenceFaceVertical', setReferenceFaceVerticals, 'value');
    getDicts('referenceFaceHorizontal', setReferenceFaceHorizontals, 'value');
    getDicts('targetHost', setTargetHosts, 'value');
  };

  useEffect(() => {
    getLabels();
    getApps();
    getSelectOptions();
  }, []);

  const handleCreate = () => {
    setVisibleAdd(true);
  };

  const wrapFn = (callback: Function, title: string, content: string, okText?: string) => {
    Modal.confirm({
      title,
      content,
      icon: <AlertFilled size={24} className={classNames('anticon', styles.alertIcon)} />,
      okText: okText || '确认',
      cancelText: '取消',
      okButtonProps: {
        type: 'primary',
        danger: true,
      },
      style: { top: '30%' },
      onOk: async () => {
        await callback();
      },
    });
  };

  const handleRecycle = (type: string, item?: any) => {
    let ids: string[] = [];
    if (type === 'batch') {
      ids = selectedElements?.map((e) => e.id) || [];
    } else {
      ids = [item.id];
    }
    wrapFn(
      async () => {
        const res = await deleteComponent(ids);
        if (res?.success) {
          message.success(`构件已删除`, 2);
          getElementsFirst(data.current, data.pageSize);
        }
      },
      '是否删除已选构件 ？',
      '删除构件后无法恢复',
      '删除',
    );
  };

  const lineText = () => {
    const isAllOffline = selectedElements?.every((s) => s.status === 'osOffline');
    return isAllOffline ? '上架' : '下架';
  };

  const handlerUpdateLineStatus = async (type: string, item?: ELEMENT.Component) => {
    let ids: string[] = [];
    let lineStatus = '';
    if (type === 'batch') {
      ids = selectedElements?.map((e) => e.id) || [];
      lineStatus = lineText() === '上架' ? 'osOffline' : 'osOnline';
    } else {
      ids = [item?.id || ''];
      lineStatus = item?.status || '';
    }
    if (lineStatus === 'osOnline') {
      wrapFn(
        async () => {
          const res = await updateComponentLineStatus({
            status: 'osOffline',
            ids,
          });
          if (res?.success) {
            message.success(`构件已下架`, 2);
            getElementsFirst(data.current, data.pageSize);
          }
        },
        '是否下架已选构件 ？',
        '下架后，相关应用将无法调用构件，已使用的构件不受影响',
        '下架',
      );
    }
    if (lineStatus === 'osOffline') {
      const res = await updateComponentLineStatus({
        status: 'osOnline',
        ids,
      });
      if (res?.success) {
        message.success(`构件已上架`, 2);
        getElementsFirst(data.current, data.pageSize);
      }
    }
  };

  const downLoadFileFn = async (item?: ELEMENT.Component) => {
    const res = await getComponentDownUrl(item?.sourceFileId || '', item?.name || '构件');
    if (res?.data?.details?.downloadUrl) {
      downLoadFile(res?.data?.details?.downloadUrl, item?.name || '构件');
    }
  };

  const exportFn = async (ids: string[]) => {
    const res = await exportFileApi(ids);
    if (res?.success) {
      message.loading({
        content: (
          <span className="report">
            文件准备中，请稍候。导出完成后，请前往
            <span
              className="report2"
              onClick={() => {
                message.destroy();
                setExportModalVisble(true);
              }}
            >
              个人中心-导出任务
            </span>
            手动下载
          </span>
        ),
      });
    }
  };

  const handleDownLoad = async (item?: ELEMENT.Component) => {
    if (item?.downloadable) {
      downLoadFileFn(item);
    } else {
      if (item?.id) {
        const res = await isDownloadable([item.id]);
        if (res?.data?.details?.allDownloadable) {
          downLoadFileFn(item);
        } else {
          if (item.currentVersionId) {
            exportFn([item.currentVersionId]);
          }
        }
      }
    }
  };

  const handleUpdate = async (item: ELEMENT.Component) => {
    setUpdateInfo((v: any) => ({ ...v, visible: true, activeData: item }));
  };

  const handleBatchDownLoad = async () => {
    // const params = selectedElements.map((m) => {
    //   return {
    //     storageFileId: m.sourceFileId || '',
    //     name: m.name || '',
    //   };
    // });
    // const res = await batchDownloadComponents(params);
    // if (res?.data) {
    //   const zipName = `构件批量打包_${dayjs().format('HH:mm')?.replace(':', '')}.zip`;
    //   downLoadFileByBlob(res.data, zipName);
    // }
    const versionIds = selectedElements.map((m) => m.currentVersionId || '');
    exportFn(versionIds);
  };

  const tagChange = (tag: string, ids: string[]) => {
    console.log(tag, '=====tagCode', tagCode);
    if (!tag && tagCode) {
      searchStore.setElement((_lib: any) => ({
        ..._lib,
        count: state.count - 1,
      }));
      dispatch({ type: 'count', payload: state.count - 1 });
    }
    if (tag && !tagCode) {
      searchStore.setElement((_lib: any) => ({
        ..._lib,
        count: state.count + 1,
      }));
      dispatch({ type: 'count', payload: state.count + 1 });
    }
    searchStore.setElement((_lib: any) => ({ ..._lib, tag: tag, tagIds: ids }));
    setTagCode(tag);
  };

  const appChange = (status: string) => {
    if (!status && appType) {
      searchStore.setElement((_lib: any) => ({
        ..._lib,
        count: state.count - 1,
      }));
      dispatch({ type: 'count', payload: state.count - 1 });
    }
    if (status && !appType) {
      searchStore.setElement((_lib: any) => ({
        ..._lib,
        count: state.count + 1,
      }));
      dispatch({ type: 'count', payload: state.count + 1 });
    }
    searchStore.setElement((_lib: any) => ({ ..._lib, appType: status }));
    setAppType(status);
  };

  const statusChange = (status: string, ids: string[]) => {
    if (!status && transferStatus) {
      searchStore.setElement((_lib: any) => ({
        ..._lib,
        count: state.count - 1,
      }));
      dispatch({ type: 'count', payload: state.count - 1 });
    }
    if (status && !transferStatus) {
      searchStore.setElement((_lib: any) => ({
        ..._lib,
        count: state.count + 1,
      }));
      dispatch({ type: 'count', payload: state.count + 1 });
    }
    searchStore.setElement((_lib: any) => ({
      ..._lib,
      transfer: status,
      transferId: ids,
    }));
    setTransferStatus(status);
    // console.log(status, 'status');
  };

  const fileTypeChange = (status: string) => {
    if (!status && fileType) {
      searchStore.setElement((_lib: any) => ({
        ..._lib,
        count: state.count - 1,
      }));
      dispatch({ type: 'count', payload: state.count - 1 });
    }
    if (status && !fileType) {
      searchStore.setElement((_lib: any) => ({
        ..._lib,
        count: state.count + 1,
      }));
      dispatch({ type: 'count', payload: state.count + 1 });
    }
    searchStore.setElement((_lib: any) => ({ ..._lib, fileType: status }));
    setFileType(status);
  };

  const onFilterClear = () => {
    tagRef?.current?.clear();
    tranRef?.current?.clear();
    fileTypeRef?.current?.clear();
    appTypeRef?.current?.clear();
  };

  const handlerOpenVersion = (item: any) => {
    operationItem.current = item;
    setVisibleVersion(true);
  };

  const showMessage = (status: string) => {
    switch (status) {
      case transferStatusEnum.waiting:
        message.error('转换中，暂不可预览');
        break;
      case transferStatusEnum.fail:
        message.error('转换失败，请更新');
        break;
      case transferStatusEnum.transfering:
        message.error('转换中，暂不可预览');
        break;
      default:
        message.error('转换中，暂不可预览');
        break;
    }
  };

  /**
   * 查看
   * @param record 表格当前行数据
   */
  const view = async (record: any, from?: string) => {
    const id = record?.componentId || record?.id || '';
    const versionId = record?.currentVersionId || record?.id || '';
    if (record.modelId) {
      //*重新转换后，列表的转换状态有延迟，导致实际状态是转换中，显示的是转换成功，点击查看显示的空白
      //*所以成功状态的，也请求一个无延迟的base接口，以获取最新状态
      const res = await getComponentBase(record.modelId);
      if (res?.success) {
        const viewFiles = res?.data?.details?.modelFiles?.filter(
          (f: any) =>
            f?.outputType?.toLocaleLowerCase() === 'gltf' ||
            f?.outputType?.toLocaleLowerCase() === 'glb',
        );
        const isTransfered =
          viewFiles?.length > 0
            ? viewFiles?.every((f: any) => f.transferStatus === transferStatusEnum.transfered)
            : false;
        if (isTransfered) {
          if (from === 'version') {
            setVisibleVersion(false);
          }
          setShowView(true);
          setViewData({
            ...record,
            name:
              record?.name || record?.sourceFileName?.replace(`.${record?.sourceFileSuffix}`, ''),
            versionId: versionId,
            componentId: id,
            signature: res?.data?.details?.signature,
          });
        } else {
          showMessage(viewFiles?.[0]?.transferStatus);
        }
      }
    } else {
      showMessage('transfering');
    }
  };

  const closeLabelModal = useCallbackFn((isRefreshList?: boolean) => {
    setVisibleTag(false);
    getLabels();
    if (isRefreshList) {
      getElementsFirst(data.current, data.pageSize);
    }
  });

  const onBatchAppChange = async () => {
    setIsEditAppOpen(true);
  };

  const onBatchCategoryChange = () => {
    setIsEditCategoryOpen(true);
  };

  const onCategoryChange = async (ids: string[], categoryId: string) => {
    // console.log(ids, '=====ids', data);
    const res = await updateComponentCategory({ componentIds: ids, tagList: [categoryId] });
    if (res?.success) {
      message.success('分类信息已修改');
      setIsEditCategoryOpen(false);
      getElementsFirst(data.current, data.pageSize);
    }
  };

  const onAppChange = async (apps: string[]) => {
    // console.log(selectedElements, '=====selectedElements', data);
    const ids = selectedElements.map((m) => m?.id || '');
    const res = await updateComponentApp({ appList: apps, componentIds: ids });
    if (res?.success) {
      message.success('应用已修改');
      setIsEditAppOpen(false);
      getElementsFirst(data.current, data.pageSize);
    }
  };

  const handleMenuClick = ({ key }: any) => {
    setAddType(key);
    handleCreate();
  };

  const onBatchEdit = useCallbackFn(async (params: any) => {
    const ids = selectedElements.map((m) => m?.id || '') || [];
    const allowSettingIds =
      selectedElements?.filter((m) => m.isAllowSetting)?.map((m) => m?.id || '') || [];
    const res = await batchUpdateComponents({
      appList: params.appList,
      componentIds: ids,
      tagList: params.categoryId ? [params.categoryId] : [],
      extDataReqDTO: {
        adsorptionCategory: params.adsorptionCategory,
        extData: params.extData,
        componentIds: allowSettingIds,
      },
    });
    if (res?.success) {
      message.success('更新成功');
      setShowBatchEdit(false);
      getElementsFirst(data.current, data.pageSize);
    }
  });

  return (
    <PageWrapper className={classNames(styles.choiceMode)}>
      <div className={classNames('pageBox', styles.pageBox)}>
        {data.isFirstLoading ? <Spin className={styles.spinWrap} /> : null}

        <>
          <div className={classNames('searchBox', { hide: data.isFirstLoading })}>
            <div className="searchLeft">
              {!data.isEmpty ? (
                <div>
                  <SearchFilter state={state} dispatch={dispatch} onClear={onFilterClear} />
                </div>
              ) : null}

              {!choiceMode && <SearchSite onClick={setVisibleTag} />}
            </div>
            <div className={classNames('searchRight', { hide: data.isEmpty })}>
              <SearchInput
                onChange={setComponentName}
                instantSearch={true}
                value={componentName}
                placeholder="请输入构件名称"
              />
              {!choiceMode && selectedElements.length > 0 && (
                <>
                  <Button className="mr12" danger onClick={() => handleRecycle('batch')}>
                    删除
                  </Button>
                  <Button
                    type="default"
                    style={{ marginRight: 12 }}
                    onClick={() => handlerUpdateLineStatus('batch')}
                  >
                    {lineText()}
                  </Button>
                  <Button className="mr12" onClick={handleBatchDownLoad}>
                    下载
                  </Button>
                  {/* <Button type="default" style={{ marginRight: 12 }} onClick={onBatchAppChange}>
                    修改应用
                  </Button>
                  <Button type="default" onClick={onBatchCategoryChange}>
                    修改分类
                  </Button> */}
                  <Button type="default" onClick={() => setShowBatchEdit(true)}>
                    批量编辑
                  </Button>
                  <div className={styles.divider} />
                </>
              )}
              {!choiceMode && <AddComBtn menuClick={handleMenuClick} />}
            </div>
          </div>

          <div className={classNames('searchFilter', { hide: !state.focus })}>
            <SearchTag ref={tagRef} labels={labels} onChange={tagChange} />
            <AppType ref={appTypeRef} options={apps} onChange={appChange} />
            <FileType ref={fileTypeRef} onChange={fileTypeChange} />
            {!choiceMode && <Transfer ref={tranRef} onChange={statusChange} />}
          </div>

          <PtxTable
            choiceMode={choiceMode}
            rowKey="id"
            showType={choiceMode ? 0 : 0}
            loading={data.isFirstLoading ? false : data.isLoading}
            dataSource={data.list}
            cardInfo={{
              titleKey: 'name',
              imageUrl: (item) => {
                if (item.thumbnailUrl) {
                  return item.thumbnailUrl;
                }
                return false;
              },
              defaultIcon: (item) => {
                if (!item.thumbnailUrl) {
                  return <EmptyMemberColor />;
                }
                return false;
              },

              renderMenu: choiceMode
                ? undefined
                : (item) => {
                    let result: any = [
                      {
                        label: (
                          <div
                            className="flex-ai-center"
                            onClick={() => {
                              handleUpdate(item);
                            }}
                          >
                            <Edit size={20} />
                            <span className="ml10">编辑</span>
                          </div>
                        ),
                        key: '3',
                      },
                      {
                        label: (
                          <div className="flex-ai-center" onClick={() => handleDownLoad(item)}>
                            <Download size={20} />
                            <span className="ml10">下载</span>
                          </div>
                        ),
                        key: '1',
                      },
                    ];
                    result = result.concat([
                      {
                        label: (
                          <div
                            className="flex-ai-center"
                            onClick={() => {
                              handlerOpenVersion(item);
                            }}
                          >
                            <HistoricVersion size={20} />
                            <span className="ml10"> 版本管理</span>
                          </div>
                        ),
                        key: '2',
                      },
                      {
                        type: 'divider',
                      },
                      {
                        label: (
                          <div
                            className="flex-ai-center"
                            onClick={() => {
                              handlerUpdateLineStatus('single', item);
                            }}
                          >
                            {item?.status !== 'osOffline' ? (
                              <>
                                <Unshelve size={20} />
                                <span className="ml10"> 下架</span>
                              </>
                            ) : (
                              <>
                                <Shelve size={20} />
                                <span className="ml10">上架</span>
                              </>
                            )}
                          </div>
                        ),
                        key: '5',
                        disabled: [
                          transferStatusEnum.transfering,
                          transferStatusEnum.waiting,
                          transferStatusEnum.fail,
                        ].includes(item?.status),
                      },
                      {
                        danger: true,
                        label: (
                          <div
                            className="flex-ai-center"
                            onClick={() => handleRecycle('single', item)}
                          >
                            <Delete size={20} />
                            <span className="ml10"> 删除</span>
                          </div>
                        ),
                        key: 4,
                      },
                    ]);
                    return <Menu items={result} />;
                  },
              onClick: (record) => {
                if (!choiceMode) {
                  view(record);
                }
              },
            }}
            rowSelection={{
              type: 'checkbox',
              selectedRowKeys: selectedElements.map((item) => item.id),
              onChange: (keys, datas) => {
                setSelectedElements(datas);
                onChoice?.(get(datas, '[0]'));
              },
            }}
            empty={{
              show: data.isNoData,
              isEmpty: data.isEmpty,
              describe: '没有构件',
              icon: <EmptyMemberColor />,
              // wrapStyle: { position: 'relative', top: '50%' },
              btnRender: () => {
                if (!choiceMode && data.isEmpty) {
                  return <AddComBtn menuClick={handleMenuClick} />;
                }
                return false;
              },
            }}
            pagination={{
              total: data.total,
              current: data.current,
              pageSize: data.pageSize,
              onChange: getElementsFirst,
            }}
          />
        </>
      </div>

      {updateInfo.visible && (
        <UpdateElement
          componentData={updateInfo.activeData as any}
          visible={updateInfo.visible}
          getElementsFirst={getElementsFirst}
          setUpdateInfo={setUpdateInfo}
          defaultTags={labels}
          defaultapps={apps}
          adsorptionCategorys={adsorptionCategorys}
          referencePointHorizontals={referencePointHorizontals}
          referencePointVerticals={referencePointVerticals}
          referenceFaceVerticals={referenceFaceVerticals}
          referenceFaceHorizontals={referenceFaceHorizontals}
          targetHosts={targetHosts}
        />
      )}

      {visibleTag && <ModalLabel visible={visibleTag} onCancel={closeLabelModal} />}

      {visibleVersion && (
        <VersionModel
          data={operationItem.current}
          visible={visibleVersion}
          onCancel={() => setVisibleVersion(false)}
          view={view}
          init={() => {
            getElementsFirst(data.current, data.pageSize);
          }} // 传入页码信息，让当前构件所在页的数据能够刷新
        />
      )}

      {visibleAdd && (
        <ComponentAdd
          visible={visibleAdd}
          onCancel={() => {
            setVisibleAdd(false);
          }}
          initData={getElementsFirst}
          type={addType}
          adsorptionCategorys={adsorptionCategorys}
          referencePointHorizontals={referencePointHorizontals}
          referencePointVerticals={referencePointVerticals}
          referenceFaceVerticals={referenceFaceVerticals}
          referenceFaceHorizontals={referenceFaceHorizontals}
          targetHosts={targetHosts}
        />
      )}

      {showView && (
        <ViewElement
          data={viewData}
          onClose={() => {
            setShowView(false);
            setViewData(undefined);
          }}
          tags={labels}
          appOption={apps}
        />
      )}

      {isEditCategoryOpen ? (
        <ChangeCategoryModal
          ids={selectedElements?.map((s) => s?.id) || []}
          selectCategoryId={''}
          categoryOptions={labels}
          onChange={onCategoryChange}
          onClose={() => setIsEditCategoryOpen(false)}
        />
      ) : null}

      {isEditAppOpen ? (
        <ChangeAppModal
          selectAppList={[]}
          appOptions={apps}
          onChange={onAppChange}
          onClose={() => setIsEditAppOpen(false)}
        />
      ) : null}

      {showBatchEdit ? (
        <BatchEdit
          // ids={selectedElements?.map((s) => s?.id) || []}
          appOptions={apps}
          onChange={onBatchEdit}
          onClose={() => setShowBatchEdit(false)}
          categoryOptions={labels}
          adsorptionCategorys={adsorptionCategorys}
          referencePointHorizontals={referencePointHorizontals}
          referencePointVerticals={referencePointVerticals}
          referenceFaceVerticals={referenceFaceVerticals}
          referenceFaceHorizontals={referenceFaceHorizontals}
          targetHosts={targetHosts}
          selects={selectedElements}
        />
      ) : null}
    </PageWrapper>
  );
};
export default Element;
